
// ==============
// = UI Actions =
// ==============

export const SELECT_DATE                 = 'SELECT_DATE'
export const SELECT_TIDE_STATION         = 'SELECT_TIDE_STATION'
export const CLEAR_SELECTED_TIDE_STATION = 'CLEAR_SELECTED_TIDE_STATION'
export const UPDATE_NOW_MOMENT           = 'UPDATE_NOW_MOMENT'
export const UPDATE_LOCATION_SEARCH      = 'UPDATE_LOCATION_SEARCH'

export const SET_PAGE_VIEW       = 'SET_PAGE_VIEW'
export const PAGE_VIEWS = {
  DAY_PAGE: 'DAY_PAGE',
  MONTH_PAGE:   'MONTH_PAGE'
}

export const OPEN_DATE_PICKER         = 'OPEN_DATE_PICKER'
export const CLOSE_DATE_PICKER        = 'CLOSE_DATE_PICKER'


// =================
// = User Location =
// =================

export const REQUEST_USER_LOCATION       = 'REQUEST_USER_LOCATION'
export const RECIEVE_USER_LOCATION_ERROR = 'RECIEVE_USER_LOCATION_ERROR'
export const RECIEVE_USER_LOCATION       = 'RECIEVE_USER_LOCATION'


// ==================
// = Tide Selection =
// ==================

export const REQUEST_TIDES = 'REQUEST_TIDES'
export const RECEIVE_TIDES = 'RECEIVE_TIDES'



// WEBPACK FOOTER //
// ./src/actions/index.js